import axios from 'axios';

const { VUE_APP_API_URL } = process.env || {};

export const getStores = (token) => axios.get(`${VUE_APP_API_URL}/api/v1/admin/stores`, {
  headers: {
    Authorization: `Bearer ${token}`, // send the access token through the 'Authorization' header
  },
});
export const getStore = (token, storeId) => axios.get(`${VUE_APP_API_URL}/api/v1/admin/store/${storeId}`, {
  headers: {
    Authorization: `Bearer ${token}`, // send the access token through the 'Authorization' header
  },
});
export const createStore = (token, body) => axios.post(`${VUE_APP_API_URL}/api/v1/admin/store`, body, {
  headers: {
    Authorization: `Bearer ${token}`, // send the access token through the 'Authorization' header
  },
});
export const updateStore = (token, id, body) => axios.put(`${VUE_APP_API_URL}/api/v1/admin/store/${id}`, body, {
  headers: {
    Authorization: `Bearer ${token}`, // send the access token through the 'Authorization' header
  },
});
export const deleteStore = (token, id) => axios.delete(`${VUE_APP_API_URL}/api/v1/admin/store/${id}`, {
  headers: {
    Authorization: `Bearer ${token}`, // send the access token through the 'Authorization' header
  },
});
export const postStoreInventory = (token, body) => axios.post(`${VUE_APP_API_URL}/api/v1/admin/inventory-store`, body, {
  headers: {
    Authorization: `Bearer ${token}`, // send the access token through the 'Authorization' header
  },
});
